import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsClojureComponent } from './simple-icons-clojure.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsClojureComponent ],
    exports:      [ SimpleIconsClojureComponent ],
    bootstrap:    []
})
export class SimpleIconsClojureModule {}
